import L from 'leaflet';
import axios from 'axios';

const PALETTE_RGB_RED = [
  [255, 255, 224], [255, 255, 197], [255, 255, 169], [255, 255, 142], [255, 246, 0],
  [255, 235, 0], [255, 225, 0], [255, 214, 0], [255, 204, 0], [255, 193, 0],
  [255, 183, 0], [255, 173, 0], [255, 165, 8], [255, 159, 24], [255, 154, 40],
  [255, 148, 56], [255, 143, 72], [255, 138, 88], [255, 132, 104], [255, 127, 120],
  [255, 117, 117], [255, 101, 101], [255, 85, 85], [255, 70, 70], [255, 54, 54],
  [255, 38, 38], [255, 23, 23], [255, 7, 7], [247, 0, 0], [232, 0, 0],
  [218, 0, 0], [203, 0, 0], [189, 0, 0], [174, 0, 0], [160, 0, 0],
  [145, 0, 0], [128, 0, 0], [111, 0, 0], [95, 0, 0], [79, 0, 0],
  [63, 0, 0], [47, 0, 0], [31, 0, 0], [15, 0, 0], [0, 0, 0]
];

const PALETTE_RGB_GREEN = [
    [230, 255, 250], [210, 250, 230], [190, 245, 210], [170, 240, 190], [150, 235, 170],
    [130, 230, 150], [110, 225, 130], [90, 220, 110], [70, 215, 90], [50, 210, 70],
    [30, 200, 50], [20, 190, 40], [10, 180, 30], [5, 170, 20], [0, 160, 10],
    [100, 180, 0], [150, 200, 0], [200, 220, 0], [230, 235, 0], [255, 255, 0],
    [255, 230, 0], [255, 210, 0], [255, 190, 0], [255, 170, 0], [255, 150, 0],
    [255, 130, 0], [255, 110, 0], [255, 90, 0], [255, 70, 0], [255, 50, 0],
    [255, 30, 0], [255, 10, 0], [240, 0, 0], [220, 0, 0], [200, 0, 0],
    [180, 0, 0], [160, 0, 0], [140, 0, 0], [110, 0, 0], [80, 0, 0],
    [60, 0, 0], [40, 0, 0], [20, 0, 0], [10, 0, 0], [0, 0, 0],
];

const PALETTES = {0: PALETTE_RGB_RED, 1: PALETTE_RGB_GREEN}

function getPaletteColor(value, minVal, maxVal) {
  const palette = PALETTES[window.paletteIndex];
  const paletteSize = palette.length;
  if (value <= minVal) {
    return palette[0];
  }
  if (value >= maxVal) {
    return palette[paletteSize - 1];
  }
  const ratio = (value - minVal) / (maxVal - minVal);
  const index = Math.floor(ratio * (paletteSize - 1));
  return palette[index];
}

export class NMTLayer extends L.TileLayer {

  createCanvasFromData(data) {
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 256;
    const ctx = canvas.getContext('2d');
    const imageData = ctx.createImageData(256, 256);

    for (let i = 0; i < data.length; i++) {
      const val = data[i];
      let r, g, b, a;
      if (val > 0) {
        [r, g, b] = getPaletteColor(val, window.paletteMin * 100, window.paletteMax * 100);
        a = window.binaryLayerAlpha || 255;
        //[r, g, b] = window.paletteMap[val];
      } else {
        [r, g, b] = [255, 255, 255];
        a = 0;
      }
      const pos = i * 4;
      imageData.data[pos] = r;
      imageData.data[pos + 1] = g;
      imageData.data[pos + 2] = b;
      imageData.data[pos + 3] = a;
    }

    ctx.putImageData(imageData, 0, 0);
    return canvas;
  }

  async downloadAndProcess(url: string, tile: HTMLImageElement, done: L.DoneCallback) {
    try {
      const response = await axios.get(url, {params: {time: Date.now()}, responseType: 'arraybuffer'});
      const data = new Uint16Array(response.data);
      const canvas = this.createCanvasFromData(data);
      tile.src = canvas.toDataURL();
      done(null, tile);
    } catch (error) {
      const data = new Uint16Array(256*256).fill(0);
      const canvas = this.createCanvasFromData(data);
      tile.src = canvas.toDataURL();
      done(null, tile);
    }
  }

  createTile(coords: L.Coords, done: L.DoneCallback) {
    const tile = document.createElement('img');
    const url = this.getTileUrl(coords);
    this.downloadAndProcess(url, tile, done);
    return tile;
  }

}